<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    filters-title="Ricerca ruoli"
    results-title="Ruoli"
    no-results-message="Nessun ruolo trovato"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <role-filters v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-col v-for="r in page.content" sm="6" md="4">
        <router-link-card
          :disabled="!r.permissions.load"
          :to="{ name: 'Role', params: { id: r.id } }">
          <div slot="header" class="font-weight-bold">
            {{ r.name }}
            <tag
              v-if="r.workgroup"
              class="ml-2"
              :value="r.workgroup.name"
            />
          </div>
          <div>
            {{ r.description }}
          </div>
        </router-link-card>
      </b-col>
    </b-row>
    <div
      v-if="page.permissions && page.permissions.create"
      slot="bottom-buttons"
      class="text-right mb-2">
      <b-button variant="success" :to="{ name: 'Role', params: { id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import RoleService from 'app/services/RoleService';
import FindPageMixin from 'vue-core/mixins/FindPageMixin';

export default {
  mixins: [ FindPageMixin ],

  created() {
    this.service = RoleService;
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Ruoli'
        }
      ];
    },

    sorters() {
      return [
        {
          label: 'Nome',
          path: 'name'
        },
      ];
    }
  }
}
</script>
